/**
 * Determines the Super Admin URL based on the current API environment.
 *
 * @param apiUrl - The API URL from VITE_KORINT_API_URL
 * @param subpath - The subpath to append (e.g., "/policies/{policyId}")
 * @param tenant - Optional tenant identifier to append as a query parameter
 * @returns The full Super Admin URL or null if localhost
 */
export function getSuperAdminUrl(apiUrl: string, subpath: string, tenant?: string): string | null {
  try {
    const url = new URL(apiUrl);
    const hostname = url.hostname;

    // localhost: return null (disabled state)
    if (hostname.includes('localhost') || hostname === '127.0.0.1') {
      return null;
    }

    let baseUrl: string | null = null;

    // develop: extract the PR number from the review (rv-<pr>) or preview (api-pv<pr>) host
    if (hostname.includes('rv-') || hostname.includes('develop')) {
      const previewMatch = hostname.match(/^api-pv(\d+)\.preview\.develop\.korint\.io$/);
      const reviewMatch = hostname.match(/rv-(\d+)/);

      if (previewMatch) {
        baseUrl = `https://super-pv${previewMatch[1]}.preview.develop.korint.io${subpath}`;
      } else if (reviewMatch) {
        baseUrl = `https://super-rv-${reviewMatch[1]}.develop.korint.io${subpath}`;
      }
    } else if (hostname.includes('staging')) {
      baseUrl = `https://super.staging.korint.io${subpath}`;
    } else {
      baseUrl = `https://super.korint.io${subpath}`;
    }

    if (!baseUrl) {
      return null;
    }

    return tenant ? `${baseUrl}?tenant=${tenant}` : baseUrl;
  } catch {
    return null;
  }
}
